import React from 'react';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const isOver18 = localStorage.getItem('isOver18') === 'true';

  if (!isOver18) {
    return <Navigate to='/welcome' replace />;
  }

  return children;
}
